'use client';
import React, { useEffect, useRef, useState } from 'react';
import Stack from '@mui/material/Stack';
import './Index.css';
import Constants from '../../../utils/constants';
import HttpService from '../../../services/HttpService';
import { useStore } from '../../../utils/store';
import UserRequest from '../../../Models/UserRequest';
import { useNavigate, useParams } from 'react-router-dom';
import IdLabelData from '../../../Models/IdLabelData';
import FormFieldData from '../../../Models/FormFieldData';
import CommonForm from '../../../components/form/CommonForm';
import AlertMessageComponent from '../../../components/AlertMessageComponent';
import CloseIcon from '@mui/icons-material/Close';
import { useAlert } from '../../../components/alertContext';
import { Box, ImageList, ImageListItem } from '@mui/material';
const UsersFormCommon: React.FC = () => {
  interface userFormFields {
    firstName: { required: boolean; value: string };
    lastName: { required: boolean; value: string };
    email: { required: boolean; value: string };
    id?: { required: boolean; value: string | null };
    phone: { required: boolean; value: string };
    empTypeTxt: { required: boolean; value: string };
    roleTxt: { required: boolean; value: any };
    contractor: { required: boolean; value: number };
  }

  const isInitialLoad = useRef(true);
  const { getAdmin, getLoginUsername } = useStore();
  const { currentId } = useParams<{ currentId: any }>();
  const navigate = useNavigate();
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const empType = [
    { id: 'Casual', label: 'Casual' },
    { id: 'Contractor', label: 'Contractor' },
    { id: 'Full Time', label: 'Full Time' },
    { id: 'Part Time', label: 'Part Time' },
  ];
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState<IdLabelData[]>([]);
  const [contractorList, setContractorList] = useState<IdLabelData[]>([]);
  const [currentRecord, setCurrentRecord] = useState<any>(null);
  const [userForm, setUserForm] = useState<userFormFields>({
    firstName: { required: true, value: '' },
    lastName: { required: true, value: '' },
    email: { required: true, value: '' },
    id: { required: false, value: null },
    phone: { required: false, value: '' },
    empTypeTxt: { required: true, value: '' },
    roleTxt: { required: true, value: [] },
    contractor: { required: false, value: 0 },
  });
  const [signaturePhotos, setSignaturePhotos] = useState<any>(null);
  const [signatureFile, setSignatureFile] = useState<any>(null);

  useEffect(() => {
    if (currentId) {
      if (currentId !== 'Add') {
        fetchSingleRecord(currentId);
      }
    } else {
      setCurrentRecord(null);
    }
  }, [currentId]);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await HttpService.get(
          Constants.apiURL + Constants.rolesURL,
          { headers: { Authorization: 'Bearer ' + getAdmin() } },
          null
        );
        if (response.success) {
          setRoles(
            response.data.map((item: any) => ({
              id: item.id,
              label: item.title,
            }))
          );
        } else {
          setRoles([]);
        }
        console.log('GET Response:', response);
      } catch (error) {
        setRoles([]);
        console.error('Error fetching data:', error);
      }
    };
    if (
      contractorList.length === 0 &&
      isInitialLoad.current &&
      isInitialLoad.current
    ) {
      fetchContractors();
    }
    if (roles.length === 0 && isInitialLoad.current) {
      fetchRoles();
    }

    isInitialLoad.current = false;

    console.log(signatureFile, signaturePhotos && currentId !== 'Add');
    if (!signatureFile && !signaturePhotos) fetchUserSignature();
  }, []);

  const handleRemove = async () => {
    setSignatureFile(null);
  };

  const handleFileChange = async (file: any) => {
    setSignatureFile(file);
  };

  const Create = async (dataObj: UserRequest) => {
    try {
      const response = await HttpService.post(
        Constants.apiURL + Constants.usersURL,
        dataObj,
        { headers: { Authorization: 'Bearer ' + getAdmin() } }
      );
      if (response.success) {
        clearForm();
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const Update = async (dataObj: UserRequest, id: number) => {
    try {
      dataObj['id'] = id;
      const response = await HttpService.put(
        Constants.apiURL + Constants.usersURL,
        dataObj,
        { headers: { Authorization: 'Bearer ' + getAdmin() } }
      );
      if (response.success) {
        clearForm();
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const fetchContractors = async () => {
    try {
      const response = await HttpService.get(
        Constants.apiURL + Constants.contractorsURL,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { search: '', limit: -1, offset: 0 }
      );
      if (response.success) {
        setContractorList([
          { id: 0, label: 'Select Contractor' }, // Default option
          ...response.data.paginateRecords.map((item: any) => ({
            id: item.id,
            label: item.name,
          })),
        ]);
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const fetchSingleRecord = async (id: any) => {
    try {
      const response = await HttpService.get(
        Constants.apiURL + Constants.usersURL + '/' + id,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        null
      );
      if (response.success) {
        handleRowClick(response.data);
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const clearForm = () => {
    setUserForm({
      firstName: { required: true, value: '' },
      lastName: { required: true, value: '' },
      email: { required: true, value: '' },
      id: { required: false, value: null },
      phone: { required: false, value: '' },
      empTypeTxt: { required: true, value: '' },
      roleTxt: { required: true, value: [] },
      contractor: { required: false, value: 0 },
    });
    setCurrentRecord(null);
    setAlert({
      type: 'error',
      message: '',
      open: false,
    });
    navigate('/data-management/user');
  };

  const fetchUserSignature = async () => {
    try {
      setLoading(true);
      const response = await HttpService.get(
        `${Constants.apiURL}${Constants.photoURL}${Constants.userSignatureURL}`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        {
          id: currentId,
          search: '',
          limit: -1,
          offset: 0,
        }
      );
      if (response.success) {
        setSignaturePhotos(response.data.paginateRecords);
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const deleteUserSignature = async () => {
    console.log(signaturePhotos);
    try {
      setLoading(true);
      const response = await HttpService.patch(
        `${Constants.apiURL}${Constants.photoURL}${Constants.userSignatureURL}`,
        { id: signaturePhotos[0].id, status: '0' },
        { headers: { Authorization: `Bearer ${getAdmin()}` } }
      );
      if (response.success) {
        setSignatureFile(null);
        setSignaturePhotos(null);
      }
    } catch (error: any) {
      setLoading(false);
      console.error(`PATCH ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleRowClick = async (record: any) => {
    setCurrentRecord(record);
    setUserForm({
      firstName: { required: true, value: record.firstName },
      lastName: { required: true, value: record.lastName },
      email: { required: true, value: record.email },
      id: { required: false, value: record.id },
      phone: { required: false, value: record.phone },
      empTypeTxt: { required: true, value: record.empType },
      roleTxt: { required: true, value: record.roleId.split(',') },
      contractor: {
        required: record.roleId.split(',').includes('7'),
        value: record.contractorId,
      },
    });
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const userReq: UserRequest = {
        email: userForm.email.value,
        empType: userForm.empTypeTxt.value,
        firstName: userForm.firstName.value,
        lastName: userForm.lastName.value,
        phone: userForm.phone.value,
        roleId: Array.from(new Set(userForm.roleTxt.value)).join(','),
        contractorId: userForm.contractor.value,
      };

      if (signatureFile) {
        for (const signature of signatureFile) {
          const signedData: any = await HttpService.handlePresignedDocument(
            signature,
            'usersignature',
            currentId,
            getAdmin(),
            `${Constants.apiURL}${Constants.photoURL}${Constants.userSignatureURL}/uploadSignedURL`
          );
          console.log(`signedData`);
          console.log(signedData);
          console.log(`signedData`);

          await HttpService.post(
            `${Constants.apiURL}${Constants.photoURL}${Constants.userSignatureURL}?id=${currentId}`,
            { filePath: signedData.filePath, fileName: signedData.fileName },
            {
              headers: {
                Authorization: 'Bearer ' + getAdmin(),
              },
            }
          );
        }
      }

      if (currentRecord) {
        await Update(userReq, currentRecord.id);
      } else {
        await Create(userReq);
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      console.error(`HTTP Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const handleUserFormChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLFormElement
    >
  ) => {
    const target: any = e.target;
    const { name, value, type } = target;
    const currentValues = userForm.roleTxt.value || [];
    if (type === 'checkbox') {
      let newValues: any = [];
      if (target.checked && value === '7') {
        newValues = [...currentValues, value];
        setUserForm((prev) => {
          return {
            ...prev,
            [name]: { required: true, value: newValues },
          };
        });
      } else if (target.checked) {
        newValues = [...currentValues, value];
        setUserForm((prev) => {
          return {
            ...prev,
            [name]: { required: true, value: newValues },
          };
        });
      } else if (!target.checked) {
        newValues = currentValues.filter((el: any) => el !== value);
        setUserForm((prev) => {
          return {
            ...prev,
            [name]: { required: true, value: newValues },
          };
        });
      }
      hadnleContractorField(newValues);
    } else {
      setUserForm((prev) => {
        return {
          ...prev,
          [name]: { ...prev[name as keyof userFormFields], value },
        };
      });
    }
  };
  let formFields: FormFieldData[] = [
    {
      name: 'firstName',
      label: 'First Name',
      value: userForm.firstName.value,
      onChange: handleUserFormChange,
      isRequired: userForm.firstName.required,
      size: 6,
      type: 'textfield',
      validationRules: [(value) => (!value ? 'First Name is required' : null)],
    },
    {
      name: 'lastName',
      label: 'Last Name',
      value: userForm.lastName.value,
      onChange: handleUserFormChange,
      isRequired: userForm.lastName.required,
      size: 6,
      type: 'textfield',
      validationRules: [(value) => (!value ? 'Last Name is required' : null)],
    },
    {
      name: 'email',
      label: 'Email ID',
      value: userForm.email.value,
      onChange: handleUserFormChange,
      isRequired: userForm.email.required,
      size: 6,
      type: 'textfield',
      inputType: 'email',
      validationRules: [
        (value) => (!value ? 'Email is required' : null),
        (value) =>
          value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
            ? 'Invalid email address'
            : null,
      ],
    },
    {
      name: 'phone',
      label: 'Phone Number',
      value: userForm.phone.value,
      onChange: handleUserFormChange,
      isRequired: userForm.phone.required,
      size: 6,
      type: 'textfield',
      inputType: 'tel',
      validationRules: [
        (value) =>
          value && !/^[+]?[0-9\s\-()]{7,15}$/i.test(value)
            ? 'Invalid Phone Number'
            : null,
      ],
    },
    {
      name: 'empTypeTxt',
      label: 'Employee Type',
      value: userForm.empTypeTxt.value,
      onChange: handleUserFormChange,
      isRequired: userForm.empTypeTxt.required,
      size: 6,
      type: 'selectField',
      options: empType,
      validationRules: [
        (value) => (!value ? 'Employee Type is required' : null),
      ],
    },
    {
      name: 'roleTxt',
      label: 'User Roles',
      value: userForm.roleTxt.value,
      onChange: handleUserFormChange,
      isRequired: userForm.roleTxt.required,
      size: 12,
      options: roles,
      type: 'multicheck',
      validationRules: [
        (value) => (!value ? 'Select at least one role' : null),
      ],
    },
    {
      name: 'contractor',
      label: 'Contractor',
      value: userForm.contractor.value,
      onChange: handleUserFormChange,
      isHidden: !userForm.roleTxt.value.includes('7'),
      isRequired: userForm.contractor.required,
      size: 6,
      options: contractorList,
      type: 'selectField',
    },
    {
      label: 'User Signature',
      multiple: true,
      isRequired: false,
      name: 'userSignature',
      value: signatureFile ?? [],
      acceptFiles: 'image/*',
      existingFiles: [],
      onChange: (file: any) => {
        handleFileChange(file);
      },
      onRemoveFile: () => {
        handleRemove();
      },
      onOpenFile: (id) => {
        HttpService.handleDownloadFile(id, getAdmin());
      },
      size: 12,
      type: 'file',
    },
    {
      type: 'custom',
      size: 12,
      isRequired: false,
      onChange: () => null,
      name: '',
      label: '',
      value: '',
      customComponent: (
        <ImageList sx={{ width: '100%' }} cols={4}>
          {signaturePhotos &&
            signaturePhotos.map((item: any) => (
              <ImageListItem key={item.document.filePath}>
                <Box sx={{ position: 'relative' }}>
                  <img
                    srcSet={`${Constants.PHOTO_CDN_URL}/${item.document.filePath}?w=248&fit=crop&auto=format&dpr=2 2x`}
                    src={`${Constants.PHOTO_CDN_URL}/${item.document.filePath}?w=248&fit=crop&auto=format`}
                    alt={'user signature'}
                    loading="lazy"
                    style={{ width: '100%' }}
                  />
                  <CloseIcon
                    sx={{
                      position: 'absolute',
                      right: 0,
                      top: 0,
                      cursor: 'pointer',
                    }}
                    onClick={deleteUserSignature}
                  />
                </Box>
              </ImageListItem>
            ))}
        </ImageList>
      ),
    },
  ];

  const hadnleContractorField = (checkBoxValues: any[]) => {
    if (checkBoxValues.includes('7') && formFields.length < 7) {
      return;
    }
    if (!checkBoxValues.includes('7') && formFields.length === 7) {
      formFields.splice(7, 1);
    }
  };
  return (
    <Stack>
      <CommonForm
        fields={formFields}
        onCancel={() => {}}
        formReset={clearForm}
        formTitle={currentId !== 'Add' ? 'Update User' : 'Add New User'}
        isLoading={loading}
        isUpdate={currentId !== 'Add' ? true : false}
        onSave={handleSave}
        actionButtonPosition="bottom"
      />
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />
    </Stack>
  );
};

export default UsersFormCommon;
